import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    FormGroup,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import React, { ChangeEvent, FC, useEffect, useState } from "react";
import { Redirect, Link as RouterLink, useLocation } from "react-router-dom";
import { LoginRequest } from "../../api";
import { isLoggedIn } from "../../components/cookies";
import * as Service from "../../services/login/login";
import { commonState, store } from "../../store";
import { colors } from "../../theme";
import { State, loginSlice } from "./store";

type Props = {
    common: commonState;
    form: State;
};

export const LoginContainer: FC<Props> = (props: Props) => {
    const typeForm = (
        e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        const newState: LoginRequest = Object.assign({}, props.form.login);
        switch (e.target.id) {
            case "login_user_input":
                newState.consoleUserId = e.target.value;
                break;
            case "login_password_input":
                newState.password = e.target.value;
                break;
        }
        store.dispatch(loginSlice.actions.setLogin(newState));
    };

    return <LoginForm {...props} typeForm={typeForm} />;
};

export const LoginOTPContainer: FC<Props> = (props: Props) => {
    const typeForm = (
        e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        const newState: LoginRequest = Object.assign({}, props.form.login);
        switch (e.target.id) {
            case "login_user_input":
                newState.consoleUserId = e.target.value;
                break;
            case "login_password_input":
                newState.password = e.target.value;
                break;
            case "login_otp_token_input":
                newState.otpToken = e.target.value;
                break;
        }
        store.dispatch(loginSlice.actions.setLogin(newState));
    };

    return <LoginForm {...props} typeForm={typeForm} withOtpToken />;
};

type LoginFormProps = Props & {
    typeForm(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void;
    withOtpToken?: boolean;
};

const LoginForm: FC<LoginFormProps> = (props: LoginFormProps) => {
    if (isLoggedIn()) {
        const location = useLocation();
        let { from } = location.state
            ? (location.state as { from: string })
            : { from: "" };

        from = Service.OpeningScreenPath(from);
        return <Redirect to={from} />;
    }

    const [allEntered, setAllEntered] = useState(false);

    useEffect(() => {
        const input = props.form.login;
        if (
            input.consoleUserId.length &&
            input.password.length &&
            (!props.withOtpToken || input.otpToken.length)
        ) {
            setAllEntered(true);
        }
    }, [props.form.login]);

    const submit = (): void => {
        Service.Login();
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 50 }}
        >
            <Grid item>
                <Card sx={{ width: 400 }}>
                    <CardContent sx={{ p: 6 }}>
                        <Typography
                            variant="h1"
                            sx={{
                                mb: 6,
                                textAlign: "center",
                                color: colors.green.main,
                                lineHeight: "40.54px",
                            }}
                        >
                            お客様探索ナビ
                            <br />
                            管理コンソール
                        </Typography>
                        <FormGroup
                            sx={{
                                "& .MuiInputBase-root, .MuiAlert-root": {
                                    mb: 4,
                                },
                                "& .MuiOutlinedInput-root": {
                                    p: 0.5,
                                },
                            }}
                        >
                            <TextField
                                id="login_user_input"
                                label="ユーザID"
                                variant="outlined"
                                defaultValue={props.form.login.consoleUserId}
                                autoFocus
                                onChange={(e) => props.typeForm(e)}
                                inputProps={{
                                    style: {
                                        backgroundColor: colors.white.main,
                                    },
                                }}
                            />
                            <TextField
                                id="login_password_input"
                                label="パスワード"
                                variant="outlined"
                                type="password"
                                defaultValue={props.form.login.password}
                                onChange={(e) => props.typeForm(e)}
                                inputProps={{
                                    style: {
                                        backgroundColor: colors.white.main,
                                    },
                                }}
                            />
                            {props.withOtpToken && (
                                <TextField
                                    id="login_otp_token_input"
                                    label="タクモニキー"
                                    variant="outlined"
                                    defaultValue={props.form.login.otpToken}
                                    autoComplete="off"
                                    onChange={(e) => props.typeForm(e)}
                                    inputProps={{
                                        style: {
                                            backgroundColor: colors.white.main,
                                        },
                                    }}
                                />
                            )}
                            {props.common.errorMessage && (
                                <Alert severity="error" variant="outlined">
                                    {props.common.errorMessage.map((msg, i) => (
                                        <span key={i}>{msg}</span>
                                    ))}
                                </Alert>
                            )}
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="center"
                            >
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={!allEntered}
                                        onClick={() => submit()}
                                        id="login_submit_button"
                                    >
                                        ログイン
                                    </Button>
                                </Grid>
                            </Grid>
                        </FormGroup>
                    </CardContent>
                </Card>
                {!props.withOtpToken && (
                    <Box sx={{ mt: 6, textAlign: "center" }}>
                        <Button
                            variant="text"
                            component={RouterLink}
                            to="/login_otp"
                        >
                            タクモニキーでのログインはこちら
                        </Button>
                    </Box>
                )}
            </Grid>
        </Grid>
    );
};
